import { defaultFetch } from 'lib/api_ts/baseApi';

export type UserForResponsibleType = {
	id: number;
	email: string;
	firstName: string;
	lastName: string;
};

export const getUsersForResponsible = async (companyId: string) => {
	return defaultFetch<UserForResponsibleType[]>(`/v0/companies/${companyId}/users`);
};

export type TaskStatusType = {
	code: string;
	name: string;
	description: string | null;
};

export const getTaskPossibleStatuses = async () => {
	return defaultFetch<TaskStatusType[]>(`/oetaskstatus`);
};
